import styled, { css } from 'styled-components/macro';
import { semiBold, mediumBold, regular, primaryFont } from 'web-ui-kit/heading';

/**
 * 02/24/2020
 *
 * File to define the font styling for Messenger Desktop Studio
 * These definitions are currently different from web-ui-kit and as
 * such need a central definition here in Studio
 *
 * https://www.figma.com/file/9LaSefYhsPIf1jlvgfLWWS/Design-Messenger?node-id=450%3A4848
 *
 */

export const H1Fonts = css`
  font-size: 32px;
  line-height: 40px;
  font-weight: ${semiBold};
`;

export const H1 = styled.h1`
  font-family: ${primaryFont};
  ${H1Fonts}
  margin: 0;
`;
H1.displayName = 'H1';

export const H2Fonts = css`
  font-size: 24px;
  line-height: 32px;
  font-weight: ${semiBold};
`;

export const H2 = styled.h2`
  font-family: ${primaryFont};
  ${H2Fonts}
  margin: 0;
`;
H2.displayName = 'H2';

export const H3Fonts = css`
  font-size: 18px;
  line-height: 24px;
  font-weight: ${semiBold};
`;

export const H3 = styled.h3`
  font-family: ${primaryFont};
  ${H3Fonts}
  margin: 0;
`;
H3.displayName = 'H3';

export const H4Fonts = css`
  font-size: 16px;
  line-height: 24px;
  font-weight: ${mediumBold};
`;

export const H4 = styled.h4`
  font-family: ${primaryFont};
  ${H4Fonts}
  margin: 0;
`;
H4.displayName = 'H4';

export const BodyFonts = css`
  font-size: 14px;
  line-height: 20px;
  font-weight: ${regular};
`;

export const Body = styled.span`
  font-family: ${primaryFont};
  ${BodyFonts}
  margin: 0;
`;
Body.displayName = 'Body';

export const BodyBold = styled(Body)`
  font-weight: ${mediumBold};
`;
BodyBold.displayName = 'BodyBold';

export const BodyBoldFlex = styled(BodyBold)`
  display: flex;
`;

export const BodySmallFonts = css`
  font-size: 12px;
  line-height: 12px;
`;

export const BodySmall = styled.span`
  font-family: ${primaryFont};
  ${BodySmallFonts}
`;
BodySmall.displayName = 'BodySmall';

export const BodySmallBoldFonts = css`
  ${BodySmallFonts}
  font-weight: ${mediumBold};
`;

export const BodySmallBold = styled(BodySmall)`
  ${BodySmallBoldFonts}
`;
BodySmallBold.displayName = 'BodySmallBold';

export const ButtonText = styled(H4)`
  line-height: 33px;
`;
ButtonText.displayName = 'ButtonText';

export const InputText = styled.input`
  font-family: ${primaryFont};
  ${BodyFonts}
`;
InputText.displayName = 'InputText';
